<template>
  <div>
    <page-header title="Organization Hierachy" breadcrumb="Dashboard > Organization Hierachy" />
    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'function' }"
          @click="currentTab = 'function'"
        >
          <p>Function</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'joblevel' }"
          @click="currentTab = 'joblevel'"
        >
          <p>Job level</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'designation' }"
          @click="currentTab = 'designation'"
        >
          <p>Designation</p>  
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'people' }"
          @click="currentTab = 'people'"
        >
          <p>People</p>  
        </div>
      </div>
      <div class="flex" v-if="currentTab != 'function'">
        <div class="mr-2 filter">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div> 
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="query"
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>
    </div>
    <hr />  
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Function from "@/components/3pl/Settings/OrganizationHierachy/Function/index";
import Joblevel from "@/components/3pl/Settings/OrganizationHierachy/JobLevel/index";
import Designation from "@/components/3pl/Settings/OrganizationHierachy/Designation/index";
import People from "@/components/3pl/Settings/OrganizationHierachy/People/index";
export default {
  components: {
    PageHeader,
    People,
    Designation,
    Joblevel,
    Function,
  },
  data() {
    return {
      currentTab: "function",
      query: '',
      count: {},
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentTab", val);
    },
  },
  mounted() {
    const currentTab = this.$store.getters.currentTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
  methods: {
    async deleteFunction() {
      try {
        await this.$_deleteFunction(this.itemToDeleteId);
        this.isDeleteModal = false;
        this.generateToast("Function successfully deleted!", "success");
        this.deletingItem = false;
        this.$refs.function.getAllFunctions();
      } catch (error) {
        // this.handleError(error);
        this.generateToast("Cannot delete this function!", "error");
        this.deletingItem = false;
      }
    },
    async deleteDesignation() {
      try {
        await this.$_deleteDesignation(this.itemToDeleteId);
        this.isDeleteModal = false;
        this.generateToast("Designation successfully deleted!", "success");
        this.deletingItem = false;
        this.$refs.designation.getAllDesignations();
      } catch (error) {
        this.handleError(error);
        this.deletingItem = false;
      }
    },
    async deletePerson() {
      try {
        await this.$_deletePeople(this.itemToDeleteId);
        this.isDeleteModal = false;
        this.generateToast("Person successfully deleted!", "success");
        this.deletingItem = false;
        this.$refs.people.getAllPeople();
      } catch (error) {
        this.handleError(error);
        // this.generateToast("Cannot delete this person!",)
        this.deletingItem = false;
      }
    },
    async deleteJobLevel() {
      try {
        await this.$_deleteJobLevel(this.itemToDeleteId);
        this.isDeleteModal = false;
        this.generateToast("Job level successfully deleted!", "success");
        this.deletingItem = false;
        this.$refs.jobLevel.getAllJobLevel();
      } catch (error) {
        // this.handleError(error);
        this.generateToast(
          "Cannot delete this level cause it is in use!",
          "error"
        );
        this.deletingItem = false;
      }
    },
    deleteItem() {
      this.deletingItem = true;
      if (this.itemToDelete == "function") {
        this.deleteFunction();
      } else if (this.itemToDelete == "designation") {
        this.deleteDesignation();
      } else if (this.itemToDelete == "jobLevel") {
        this.deleteJobLevel();
      } else {
        this.deletePerson();
      }
    },
    showDeleteModal(id, itemToDelete) {
      this.itemToDeleteId = id;
      this.itemToDelete = itemToDelete;
      this.isDeleteModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
}
</style>